/* eslint-disable camelcase */
import { linkResolver } from '../../helpers/linkResolver';

const getContentSliceProps = (sliceData) => {
  if (sliceData === null) return null;
  const { primary } = sliceData;
  const {
    layout,
    content_heading,
    content_subtitle,
    content_text,
  } = primary;
  const heading = content_heading?.text?.trim() || null;
  const subtitle = content_subtitle?.text?.trim() || null;
  const subtitleType = content_subtitle?.richText[0]?.type || null;
  const text = content_text;

  let buttonUrl = null;
  let buttonText = null;
  let isExternal = false;

  // Check if there is button text and url and assign them to readable variables
  if (primary.content_button_text && primary.content_button_text.text && primary.content_button_url) {
    buttonText = primary.content_button_text?.text?.trim() || null;

    // Support both legacy `.raw` structure and direct link field structure from Prismic
    let buttonLinkField = primary.content_button_url.raw || primary.content_button_url;

    // In some Gatsby/Prismic configurations, `raw` can be a JSON string
    if (typeof buttonLinkField === 'string') {
      try {
        buttonLinkField = JSON.parse(buttonLinkField);
      } catch (e) {
        buttonLinkField = null;
      }
    }

    if (buttonLinkField && buttonLinkField.url) {
      isExternal = buttonLinkField.link_type !== 'Document';

      buttonUrl = isExternal
        ? buttonLinkField.url
        : linkResolver({
          type: buttonLinkField.type,
          uid: buttonLinkField.uid,
        });
    }
  }

  return {
    layout,
    heading,
    subtitle,
    subtitleType,
    text,
    buttonText,
    buttonUrl,
    isExternal,
  };
};

export default getContentSliceProps;
